import { 
  collection, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where,
} from "firebase/firestore";
import { db } from "../lib/firebase";

const docToTax = (id, data) => ({
  id,
  name: data.name,
  rate: data.rate,
  taxType: data.taxType || "EXCLUSIVE",
  isActive: data.isActive,
  isDeleted: data.isDeleted || false,
});

export const getTaxes = async (activeOnly = true) => {
  const constraints = [where("isDeleted", "==", false)];
  if (activeOnly) constraints.push(where("isActive", "==", true));
  
  const q = query(collection(db, "taxes"), ...constraints);
  const snap = await getDocs(q);
  return snap.docs.map(d => docToTax(d.id, d.data()));
};

export const getTaxById = async (id) => {
  if (!id) return null;
  const d = await getDoc(doc(db, "taxes", id));
  if (!d.exists()) return null;
  return docToTax(d.id, d.data());
};
